<dynamic-form [apiName]="apiName"
              [label]="label"
              [group]="formGroup"
              [areaName]="areaName"
              [model]="model"
              [columns]="columns"
              (cancelChange)="cancel()"
              (submitChange)="save()">
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{erroremessage}}
      </div>
    </div>
  </ng-container>
</dynamic-form>
